// Known locations for context-based geocoding (100+ world locations)
export const KNOWN_LOCATIONS = {
  // US States
  'texas': { lat: 31.9686, lng: -99.9018 },
  'california': { lat: 36.7783, lng: -119.4179 },
  'new york': { lat: 40.7128, lng: -74.0060 },
  'florida': { lat: 27.6648, lng: -81.5158 },
  'washington': { lat: 47.7511, lng: -120.7401 },
  'washington dc': { lat: 38.9072, lng: -77.0369 },
  'virginia': { lat: 37.4316, lng: -78.6569 },
  'illinois': { lat: 40.6331, lng: -89.3985 },
  'pennsylvania': { lat: 41.2033, lng: -77.1945 },
  'ohio': { lat: 40.4173, lng: -82.9071 },
  'georgia': { lat: 32.1656, lng: -82.9001 },
  'north carolina': { lat: 35.7596, lng: -79.0193 },
  'michigan': { lat: 44.3148, lng: -85.6024 },
  'arizona': { lat: 34.0489, lng: -111.0937 },
  'colorado': { lat: 39.5501, lng: -105.7821 },
  'massachusetts': { lat: 42.4072, lng: -71.3824 },
  'oregon': { lat: 43.8041, lng: -120.5542 },
  'connecticut': { lat: 41.6032, lng: -73.0877 },
  'alaska': { lat: 64.2008, lng: -152.4937 },
  'hawaii': { lat: 19.8968, lng: -155.5828 },
  // US Cities
  'houston': { lat: 29.7604, lng: -95.3698 },
  'midland': { lat: 31.9973, lng: -102.0779 },
  'new haven': { lat: 41.3083, lng: -72.9279 },
  'gettysburg': { lat: 39.8309, lng: -77.2311 },
  'los angeles': { lat: 34.0522, lng: -118.2437 },
  'chicago': { lat: 41.8781, lng: -87.6298 },
  'san francisco': { lat: 37.7749, lng: -122.4194 },
  'seattle': { lat: 47.6062, lng: -122.3321 },
  'boston': { lat: 42.3601, lng: -71.0589 },
  'miami': { lat: 25.7617, lng: -80.1918 },
  'dallas': { lat: 32.7767, lng: -96.7970 },
  'atlanta': { lat: 33.7490, lng: -84.3880 },
  'denver': { lat: 39.7392, lng: -104.9903 },
  'phoenix': { lat: 33.4484, lng: -112.0740 },
  'detroit': { lat: 42.3314, lng: -83.0458 },
  'philadelphia': { lat: 39.9526, lng: -75.1652 },
  'san diego': { lat: 32.7157, lng: -117.1611 },
  'portland': { lat: 45.5152, lng: -122.6784 },
  'las vegas': { lat: 36.1699, lng: -115.1398 },
  'austin': { lat: 30.2672, lng: -97.7431 },
  'nashville': { lat: 36.1627, lng: -86.7816 },
  'new orleans': { lat: 29.9511, lng: -90.0715 },
  'pittsburgh': { lat: 40.4406, lng: -79.9959 },
  'minneapolis': { lat: 44.9778, lng: -93.2650 },
  'san antonio': { lat: 29.4241, lng: -98.4936 },
  'salt lake city': { lat: 40.7608, lng: -111.8910 },
  // US Landmarks
  'yale': { lat: 41.3163, lng: -72.9223 },
  'harvard': { lat: 42.3770, lng: -71.1167 },
  'mit': { lat: 42.3601, lng: -71.0942 },
  'stanford': { lat: 37.4275, lng: -122.1697 },
  'air force': { lat: 38.8719, lng: -77.0563 },
  'pentagon': { lat: 38.8719, lng: -77.0563 },
  'white house': { lat: 38.8977, lng: -77.0365 },
  'silicon valley': { lat: 37.3875, lng: -122.0575 },
  'wall street': { lat: 40.7068, lng: -74.0089 },
  'cape canaveral': { lat: 28.3922, lng: -80.6077 },
  // Countries & Regions
  'united states': { lat: 39.8283, lng: -98.5795 },
  'usa': { lat: 39.8283, lng: -98.5795 },
  'america': { lat: 39.8283, lng: -98.5795 },
  'canada': { lat: 56.1304, lng: -106.3468 },
  'mexico': { lat: 23.6345, lng: -102.5528 },
  'brazil': { lat: -14.2350, lng: -51.9253 },
  'argentina': { lat: -38.4161, lng: -63.6167 },
  'england': { lat: 51.5074, lng: -0.1278 },
  'united kingdom': { lat: 55.3781, lng: -3.4360 },
  'france': { lat: 46.2276, lng: 2.2137 },
  'germany': { lat: 51.1657, lng: 10.4515 },
  'italy': { lat: 41.8719, lng: 12.5674 },
  'spain': { lat: 40.4637, lng: -3.7492 },
  'russia': { lat: 61.5240, lng: 105.3188 },
  'china': { lat: 35.8617, lng: 104.1954 },
  'japan': { lat: 36.2048, lng: 138.2529 },
  'india': { lat: 20.5937, lng: 78.9629 },
  'australia': { lat: -25.2744, lng: 133.7751 },
  'south korea': { lat: 35.9078, lng: 127.7669 },
  'south africa': { lat: -30.5595, lng: 22.9375 },
  'egypt': { lat: 26.8206, lng: 30.8025 },
  'israel': { lat: 31.0461, lng: 34.8516 },
  'saudi arabia': { lat: 23.8859, lng: 45.0792 },
  'turkey': { lat: 38.9637, lng: 35.2433 },
  'iran': { lat: 32.4279, lng: 53.6880 },
  'nigeria': { lat: 9.0820, lng: 8.6753 },
  'ukraine': { lat: 48.3794, lng: 31.1656 },
  'poland': { lat: 51.9194, lng: 19.1451 },
  'sweden': { lat: 60.1282, lng: 18.6435 },
  'norway': { lat: 60.4720, lng: 8.4689 },
  'switzerland': { lat: 46.8182, lng: 8.2275 },
  'netherlands': { lat: 52.1326, lng: 5.2913 },
  // Major World Cities
  'london': { lat: 51.5074, lng: -0.1278 },
  'paris': { lat: 48.8566, lng: 2.3522 },
  'berlin': { lat: 52.5200, lng: 13.4050 },
  'rome': { lat: 41.9028, lng: 12.4964 },
  'madrid': { lat: 40.4168, lng: -3.7038 },
  'moscow': { lat: 55.7558, lng: 37.6173 },
  'beijing': { lat: 39.9042, lng: 116.4074 },
  'shanghai': { lat: 31.2304, lng: 121.4737 },
  'tokyo': { lat: 35.6762, lng: 139.6503 },
  'delhi': { lat: 28.7041, lng: 77.1025 },
  'mumbai': { lat: 19.0760, lng: 72.8777 },
  'sydney': { lat: -33.8688, lng: 151.2093 },
  'melbourne': { lat: -37.8136, lng: 144.9631 },
  'toronto': { lat: 43.6532, lng: -79.3832 },
  'vancouver': { lat: 49.2827, lng: -123.1207 },
  'seoul': { lat: 37.5665, lng: 126.9780 },
  'singapore': { lat: 1.3521, lng: 103.8198 },
  'hong kong': { lat: 22.3193, lng: 114.1694 },
  'dubai': { lat: 25.2048, lng: 55.2708 },
  'istanbul': { lat: 41.0082, lng: 28.9784 },
  'cairo': { lat: 30.0444, lng: 31.2357 },
  'lagos': { lat: 6.5244, lng: 3.3792 },
  'cape town': { lat: -33.9249, lng: 18.4241 },
  'buenos aires': { lat: -34.6037, lng: -58.3816 },
  'sao paulo': { lat: -23.5505, lng: -46.6333 },
  'mexico city': { lat: 19.4326, lng: -99.1332 },
  'amsterdam': { lat: 52.3676, lng: 4.9041 },
  'stockholm': { lat: 59.3293, lng: 18.0686 },
  'oslo': { lat: 59.9139, lng: 10.7522 },
  'zurich': { lat: 47.3769, lng: 8.5417 },
  'vienna': { lat: 48.2082, lng: 16.3738 },
  'prague': { lat: 50.0755, lng: 14.4378 },
  'warsaw': { lat: 52.2297, lng: 21.0122 },
  'athens': { lat: 37.9838, lng: 23.7275 },
  'lisbon': { lat: 38.7223, lng: -9.1393 },
  'dublin': { lat: 53.3498, lng: -6.2603 },
  'bangkok': { lat: 13.7563, lng: 100.5018 },
  'jakarta': { lat: -6.2088, lng: 106.8456 },
  'kuala lumpur': { lat: 3.1390, lng: 101.6869 },
  'taipei': { lat: 25.0330, lng: 121.5654 },
  'jerusalem': { lat: 31.7683, lng: 35.2137 },
  'nairobi': { lat: -1.2921, lng: 36.8219 },
};

// US ZIP code prefix -> approximate state center coordinates
export const ZIP_REGIONS = {
  '0': { lat: 42.3, lng: -71.8, place: 'New England' },
  '1': { lat: 40.7, lng: -74.0, place: 'NY/NJ Area' },
  '2': { lat: 38.9, lng: -77.0, place: 'Mid-Atlantic' },
  '3': { lat: 33.5, lng: -84.4, place: 'Southeast' },
  '4': { lat: 39.8, lng: -86.2, place: 'Midwest East' },
  '5': { lat: 44.0, lng: -93.3, place: 'Midwest West' },
  '6': { lat: 32.8, lng: -96.8, place: 'South Central' },
  '7': { lat: 30.3, lng: -97.7, place: 'Texas/South' },
  '8': { lat: 39.7, lng: -105.0, place: 'Mountain West' },
  '9': { lat: 37.8, lng: -122.4, place: 'West Coast' }
};
